export const getInitialFbCompetitionValues = date => ({
  type: 'FACEBOOK_COMPETITION',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Google Sheet Append',
          action: 'GOOGLE_SHEET_APPEND',
          sheetUrl: '',
          row: ''
        }
      ],
      triggers: [
        {
          type: 'Match Hashtag',
          value: []
        },
        {
          type: 'Only',
          value: 'comment'
        }
      ],
      platform: 'facebook',
      description: 'Opt-In',
      operator: 'all'
    }
  ],
  moderated: false,
  moderators: { handles: [] },
  automated: false,
  threshold: 20,
  enableFiltering: false,
  enableBlastFiltering: false,
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-competition/create/container/initialValues.js